<template>
  <el-dropdown placement="bottom" trigger="click" @command="onCommand">
    <el-tooltip content="More" transition="el-zoom-in-bottom" placement="top">
      <div class="__command-button">
        <i class="el-icon-more has-margin-top has-margin-horizontal"></i>
      </div>
    </el-tooltip>
    <el-dropdown-menu slot="dropdown" class="el-tiptap-dropdown-menu">
      <el-dropdown-item
        v-if="showVideo"
        class="el-tiptap-dropdown-menu__item"
        :command="{ showVideo: false }"
      >
        <span>Hide Video</span>
      </el-dropdown-item>
      <el-dropdown-item
        v-if="!showVideo"
        class="el-tiptap-dropdown-menu__item"
        :command="{ showVideo: true }"
      >
        <span>Show Video</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import EventBus from '@/helpers/event-bus';

export default {
  name: 'MoreCommandsMenu',
  data() {
    return {
      showVideo: true,
    };
  },
  computed: {
    tooltipText() {
      return this.showVideo ? 'Hide Video' : 'Show Video';
    },
  },
  methods: {
    onCommand(command) {
      if (command.showVideo !== undefined) {
        this.showVideo = command.showVideo;
        EventBus.$emit('editor.setShowVideo', this.showVideo);
      }
    },
  },
};
</script>
